import { ISection } from '../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
import { SectionDetailsQuery } from '../section_details/queries/section_details_query';

export class MeetingTimesController {
  private section: ISection;
  private isOnline: boolean = false;
  private hasTimes: boolean = false;
  constructor(private ngSectionDetailsQuery: SectionDetailsQuery) {}

  $onChanges() {
    this.hasTimes = this.ngSectionDetailsQuery.result.meeting_times.length > 0;
    this.isOnline = _4.get(this.ngSectionDetailsQuery, 'result.section._campus.is_online', false);
  }
}

angular.module('capability-ng-scheduler').component('meetingTimes', {
  templateUrl: 'capability-ng-scheduler/src/components/meeting_times/meeting_times.html',
  controller: MeetingTimesController,
  bindings: {
    section: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/meeting_times/meeting_times.ts